import { useId, useState } from "react";
import RecentRegChips from "./RecentRegChips";
import { cleanRegistration, isValidUkRegistration } from "../utils/registration";

// SBR guide articles only: yellow UK plate field + Check, free /vehicle/{reg} flow.
export default function GuideRegSearch({
  heading = "Check a vehicle while you read",
  copy = "Enter a UK registration to open the free vehicle page.",
}) {
  const fieldId = useId();
  const [vrm, setVrm] = useState("");
  const [error, setError] = useState("");

  const goToVehicle = (raw) => {
    const cleanVrm = cleanRegistration(raw);
    if (!isValidUkRegistration(cleanVrm)) {
      setError("Enter a valid UK registration to continue.");
      return false;
    }
    window.location.href = `/vehicle/${cleanVrm.toLowerCase()}`;
    return true;
  };

  const onSubmit = (event) => {
    event.preventDefault();
    goToVehicle(vrm);
  };

  return (
    <section className="guide-reg-search" aria-label="Check a UK registration">
      <h2>{heading}</h2>
      <p>{copy}</p>
      <form className="guide-reg-search-form" onSubmit={onSubmit} noValidate>
        <div className="guide-reg-plate" aria-hidden={false}>
          <span className="guide-reg-band" aria-hidden="true">
            <img src="/gb-flag.svg" alt="" width="17" height="11" />
            <b>UK</b>
          </span>
          <label className="sr-only" htmlFor={fieldId} style={{ position: "absolute", clip: "rect(0,0,0,0)" }}>
            Vehicle registration
          </label>
          <input
            id={fieldId}
            className="guide-reg-input"
            maxLength="8"
            placeholder="ENTER REG"
            autoComplete="off"
            inputMode="text"
            value={vrm}
            onChange={(event) => {
              setVrm(cleanRegistration(event.target.value));
              setError("");
            }}
          />
        </div>
        <button className="guide-reg-submit" type="submit">Check</button>
      </form>
      <RecentRegChips
        brandKey="sbr"
        variant="sbr"
        className="guide-reg-recent"
        onSelect={(reg) => {
          const clean = cleanRegistration(reg);
          setVrm(clean);
          setError("");
          goToVehicle(clean);
        }}
      />
      <div className="guide-reg-error" role="alert" aria-live="polite">{error}</div>
    </section>
  );
}
